import { memo } from "react";
import type { SvgProps } from "react-native-svg";
import Svg, { Path } from "react-native-svg";

const SvgTrophyOutline = (props: SvgProps) => (
  <Svg width={36} height={35} fill="none" {...props}>
    <Path
      stroke="#000154"
      strokeWidth={2.5}
      d="M18 23.9c-9.216 0-10.848-9.183-11.136-16.47-.081-2.026-.121-3.04.64-3.976.76-.938 1.67-1.091 3.493-1.398A42 42 0 0 1 18 1.5c2.855 0 5.205.252 7.003.556 1.823.307 2.733.46 3.495 1.398.761.938.72 1.95.64 3.976-.288 7.287-1.92 16.47-11.136 16.47z"
    />
    <Path stroke="#000154" strokeLinecap="round" strokeWidth={2.5} d="M18 23.901v4.8" />
    <Path
      stroke="#000154"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2.5}
      d="M23.6 33.5H12.4l.544-2.713a1.6 1.6 0 0 1 1.568-1.287h6.976a1.6 1.6 0 0 1 1.568 1.287z"
    />
    <Path
      stroke="#000154"
      strokeWidth={2.5}
      d="m29.2 6.3 1.518.505c1.584.528 2.376.792 2.83 1.42.452.63.452 1.466.452 3.134v.116c0 1.376 0 2.066-.331 2.63-.331.562-.935.897-2.138 1.567L26.8 18.3m-20-12-1.518.506c-1.584.528-2.376.792-2.83 1.42C2 8.856 2 9.692 2 11.36v.116c0 1.376 0 2.066.331 2.63.331.562.935.897 2.138 1.567L9.2 18.3m7.434-10.363C17.242 6.843 17.546 6.3 18 6.3s.758.544 1.366 1.637l.157.282c.173.31.26.464.394.566.136.103.304.141.64.216l.304.07c1.18.268 1.771.4 1.912.852.14.451-.263.923-1.067 1.864l-.208.243c-.23.267-.344.4-.396.566-.05.167-.033.344 0 .701l.032.325c.122 1.256.183 1.885-.184 2.163-.368.279-.921.024-2.027-.485l-.285-.13c-.315-.145-.472-.217-.638-.217s-.323.072-.638.216l-.285.131c-1.106.51-1.66.764-2.027.485-.368-.278-.306-.907-.184-2.163l.032-.325c.033-.357.05-.534 0-.7-.052-.167-.167-.3-.396-.567l-.208-.243c-.804-.941-1.208-1.411-1.067-1.864.141-.451.731-.584 1.912-.851l.304-.07c.336-.076.504-.113.64-.217.135-.102.221-.256.394-.566z"
    />
    <Path stroke="#000154" strokeLinecap="round" strokeWidth={2.5} d="M27.6 33.5H8.4" />
  </Svg>
);
const Memo = memo(SvgTrophyOutline);
export default Memo;
